import { ModalConfig } from '@contexts/modalContext';
import VoterRegistrationSuccessModal from './VoterRegistrationSuccessModal';
import VoterRegistrationFailureModal from './VoterRegistrationFailureModal';
import VoterRegistrationCancelModal from './VoterRegistrationCancelModal';

export const modalConfig: ModalConfig = {
    VoterRegistrationSuccessModal: {
        id: 'VoterRegistrationSuccessModal',
        modalComponent: VoterRegistrationSuccessModal,
    },
    VoterRegistrationFailureModal: {
        id: 'VoterRegistrationFailureModal',
        modalComponent: VoterRegistrationFailureModal,
    },
    VoterRegistrationCancelModal: {
        id: 'VoterRegistrationCancelModal',
        modalComponent: VoterRegistrationCancelModal,
    },
};
